/*
* Switch gallery awards with fade
*/
document.addEventListener('DOMContentLoaded', function() {
  var menuItems = document.querySelectorAll('.awards-container--menu_item a');
  var galleries = document.querySelectorAll('.awards-container--galleries_gallery');

  // Ajoute une classe "hidden" à toutes les galeries sauf la première
  for (var i = 1; i < galleries.length; i++) {
    galleries[i].classList.add('hidden');
  }

  // Ajoute un gestionnaire d'événement de clic à chaque lien du menu
  menuItems.forEach(function(item) {
    item.addEventListener('click', function(event) {
      event.preventDefault();

      // Récupère la valeur de l'attribut "data-attribute"
      var targetId = item.getAttribute('data-attribute');

      // Cache toutes les galeries avec une transition de fondu
      galleries.forEach(function(gallery) {
        gallery.classList.add('fade-out');
      });

      // Affiche la galerie correspondante après un court délai
      setTimeout(function() {
        // Cache toutes les galeries
        galleries.forEach(function(gallery) {
          gallery.classList.add('hidden');
          gallery.classList.remove('fade-out');
        });

        // Affiche la galerie correspondante
        var targetGallery = document.getElementById(targetId);
        if (targetGallery) {
          targetGallery.classList.remove('hidden');
        }
      }, 300); // Durée de la transition en millisecondes (ajustez selon vos besoins)
    });
  });
});

